import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  redirect,
  Route,
} from "react-router-dom";
import './index.css';
import Page from './route/Page';
import Album from './route/Album';
import Artist from './route/Artist';
import Song from './route/Song';
import Composer from './route/Composer';
import Creator from './route/Creator';
import ErrorPage from './route/ErrorPage';

import { FooterStateProvider } from './lib/varFooter';
import { SongListStateProvider } from './lib/varSongList';
import { SongDetailStateProvider } from './lib/varSongDetail';
import { ArtistStateProvider } from './lib/varArtist';
import { AlbumStateProvider } from './lib/varAlbum';
import { ComposerStateProvider } from './lib/varComposer';
import { CreatorStateProvider } from './lib/varCreator';
import { HeaderStateProvider } from './lib/varHeader';
import { FilterStateProvider } from './lib/varFilter';
import { SummaryStateProvider } from './lib/varSummary';

const rootDir: string = '/rs+/'
export default rootDir

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route 
      path={rootDir}
      errorElement={<ErrorPage />}
    >
      <Route path={rootDir+'page/'} loader={ () => { return redirect(rootDir+'page/1') } } />
      <Route path={rootDir} loader={ () => { return redirect(rootDir+'page/1') } } />
      <Route element={<Page />} path={rootDir+'page/:pageNo'} />
      <Route element={<Album />} path={rootDir+'album/:albumID'} />
      <Route element={<Artist />} path={rootDir+'artist/:artistID'} />
      <Route element={<Song />} path={rootDir+'song/:songID'} />
      <Route element={<Composer />} path={rootDir+'composer/:composerID'} />
      <Route element={<Creator />} path={rootDir+'creator/:creatorID'} />
    </Route>
  )
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <FooterStateProvider>
      <HeaderStateProvider>
        <FilterStateProvider>
          <SummaryStateProvider>
            <SongListStateProvider>
              <SongDetailStateProvider>
                <ArtistStateProvider>
                  <AlbumStateProvider>
                    <ComposerStateProvider>
                      <CreatorStateProvider>
                        <RouterProvider router={router}/>
                      </CreatorStateProvider>
                    </ComposerStateProvider>
                  </AlbumStateProvider>
                </ArtistStateProvider>
              </SongDetailStateProvider>
            </SongListStateProvider>
          </SummaryStateProvider>
        </FilterStateProvider>
      </HeaderStateProvider>
    </FooterStateProvider>
  </React.StrictMode>
);

// export default { rootDir, apiUrl }